module.exports = __webpack_public_path__ + "img/2.b6425ee7.webp";